module.exports = __webpack_public_path__ + "static/media/01.39adc804.jpg";